import React from 'react';
import { Link } from 'react-router-dom';

import aboutImg from '../../assets/images/about/ab.png'
import shapeImg from '../../assets/images/about/badge.png'
//{/***  <div className="react_populars_topics react_populars_topics2 react_populars_topics_about pb---80">***/}
const AboutPart = () => {

    return (
        
        <div className="about__area about__area_one p-relative pt---100 pb---120"
        style={{backgroundColor: 'white'}}
        >
            <div className="container"> 
                <div className="row">
                    
                    <div className="col-lg-2">
                        {/*** *
                        <div className="about__image wow animate__fadeInUp" data-wow-duration="0.3s">
                           
                            <img src={aboutImg} alt="About" />
                            <img className="react__shape__ab" src={shapeImg} alt="Shape Image" />

                        </div>
                        ***/}
                    </div>
                   
                    <div className="col-lg-8">
                        <div className="about__content">
                           
                            <h2 className="about__title wow animate__fadeInUp" data-wow-duration="0.3s">
                                Welcome to 
                                <br/> 
                                <em>eTriangle</em>
                            </h2>

                            <p className="about__paragraph wow animate__fadeInUp" data-wow-duration="0.5s">ETriangle is a Tanzanian company dedicated to transforming the education ecosystem by bridging the communication gap between parents, teachers and students.

                          Through innovation, we ensure that the Education Triangle is complete, 
                          fostering a collaborative and effective learning environment.

                            With seven years of experience in education initiatives and officially 
                            registered in 2025, 

                                <br/> we have built a strong foundation in leveraging 
                            technology and strategic partnerships to enhance communication and 
                            academic performance in schools..
                            </p>


                            <p className="about__paragraph wow animate__fadeInUp" data-wow-duration="0.7s">
                            Our Mission
                             <br/>
                              To enhance seamless communication between parents, teachers and students, 
                              ensuring every learner receives the necessary support 
                              for academic and personal success.


                            </p>
                            
                            <p className="about__paragraph wow animate__fadeInUp" data-wow-duration="0.9s">
                            Our Vision
                            <br/>
                            To be the leading education innovation partner in Tanzania, 
                            setting the standard for effective communication and collaboration in the 
                            school system.

                              
                            </p>

                            <p className="about__paragraph wow animate__fadeInUp" data-wow-duration="0.9s">
                              Our Core Values
                              <br/>

                                 Innovation – Leveraging technology to drive educational success.
                                 <br/>
                                Collaboration – Strengthening partnerships between parents, teachers, and students.
                                <br/>
                                Excellence – Delivering quality solutions that improve learning outcomes.
                                integrity – Upholding transparency and accountability in all engagements.
                                <br/>
                                Commitment – Dedicated to making a lasting impact on education in Tanzania.


                            </p>
                           
                           <p className="about__paragraph  wow animate__fadeInUp">

                            
                           Our Solutions & Services
                           <br/>

1. School Communication System
<br/>
We provide innovative tools and platforms to facilitate real-time and structured communication between teachers, parents and students, ensuring transparency and engagement.
<br/>
<br/>
2. Student Performance Monitoring
<br/>
Our solutions help track student progress, providing timely updates to parents and allowing teachers to identify learning gaps for better intervention.
<br/>
<br/>
3. Digital Learning Support
<br/>
ETriangle integrates e-learning tools to complement traditional education, making learning more accessible and interactive.
<br/>
<br/>
4. School Management Consulting
<br/>

We work with schools to implement best practices in communication, administration and academic planning for overall institutional growth.
<br/>
<br/>
5. Parent-Teacher Engagement Programs
<br/>
We create platforms for parental involvement in students' academic journeys, ensuring better support and collaboration.
<br/>
<br/>
                           </p>

                           <p className="about__paragraph  wow animate__fadeInUp">
                            
                           <br/>
6. Why Choose ETriangle?
<br/>
✅ Proven Experience: 7+ years in education-focused initiatives.
<br/>
✅ Tech-Driven Solutions: Innovative tools for effective communication.
<br/>
✅ Impact-Oriented Approach: Enhancing learning outcomes through collaboration.
<br/>
✅ Tanzania’s Trusted Partner: Supporting schools nationwide.
<br/>
<br/>


                           </p>

                           <p className="about__paragraph  wow animate__fadeInUp">

<br/>                            
7. Our Impact
<br/>  
Successfully facilitated communication in multiple schools across Tanzania.
<br/>  
Helped thousands of parents stay informed about their children’s education.
<br/>  
Partnered with educational institutions to improve learning efficiency.

<br/>  

                           </p>
                          
                          

<p className="about__paragraph  wow animate__fadeInUp">

<br/>                             
 Contact Us
<br/>  

</p>
                            <ul>

                                {/*** *
                                <li><Link to="/about" className="more-about wow animate__fadeInUp" data-wow-duration="1.2s"> 
                                
                                Read More <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19">
                                    </polyline></svg></Link>
                                </li>
                                
                                <li className="last-li wow animate__fadeInUp" data-wow-duration="1.3s">
                                    <em>Get Support</em>
                                    <a href="mailto:support@react.com">support@react.com</a>
                                </li>
                                ***/}
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-2">
                        {/*** *
                        <div className="about__image wow animate__fadeInUp" data-wow-duration="0.3s">
                           
                            <img src={aboutImg} alt="About" />
                            <img className="react__shape__ab" src={shapeImg} alt="Shape Image" />

                        </div>
                        ***/}
                    </div>

                </div>
            </div>
        </div>
    );
}

export default AboutPart;